import ProductList from './ProductList.vue'

export default {
  name: 'BuyXGetYOff',

  props: {
    value: {},
    shown: Boolean
  },

  data () {
    return {
      tab: 0,
      promotion: {
        targetMargin: null,
        rewardsSubsidy: null,
        page: null,
        oncePerDay: null,
        positionOnPage: null,
        requirements: {
          purchasedProducts: [],
          purchasedAmount: null
        },
        rewards: {
          redemptionLimit: null,
          salesRedemptionLimit: null,
          rewardMoneyEarnedPerRedemption: null,
          sumOff: null,
          percentageOff: null
        }
      }
    }
  },

  computed: {
    // TODO: Duplicate
    name () {
      // TOOD: make some text adjustments
      let name = 'Buy '
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X'
      name += ' and get Y'
      name += ' for '
      if (this.promotion.rewards.sumOff) {
        name += this.promotion.rewards.sumOff + '$ off'
      } else if (this.promotion.rewards.percentageOff) {
        name += this.promotion.rewards.percentageOff + '% off'
      } else {
        // name += 'free or reduced price'
      }

      return name
    },

    discountedPriceFormula () {
      return (basePrice) => {
        if (this.promotion.rewards.sumOff) {
          return basePrice - this.promotion.rewards.sumOff
        } else if (this.promotion.rewards.percentageOff) {
          return basePrice - basePrice * this.promotion.rewards.percentageOff / 100
        } else {
          return basePrice
        }
      }
    }
  },

  components: {
    'product-list': ProductList
  },

  methods: {
    reset () {
      if (this.value) {
        this.promotion.customerGroupId = this.value.customerGroupId
        this.promotion.targetMargin = this.value.targetMargin
        this.promotion.rewardsSubsidy = this.value.rewardsSubsidy
        this.promotion.oncePerDay = this.value.oncePerDay
        this.promotion.requirements.purchasedAmount = this.value.requirements.purchasedAmount
        this.promotion.requirements.purchasedProducts = this.value.requirements.purchasedProducts
        this.promotion.rewards.rewardMoneyEarnedPerRedemption = this.value.rewards.rewardMoneyEarnedPerRedemption
        this.promotion.rewards.sumOff = this.value.rewards.sumOff
        this.promotion.rewards.percentageOff = this.value.rewards.percentageOff
        this.promotion.rewards.redemptionLimit = this.value.rewards.redemptionLimit
        this.promotion.rewards.salesRedemptionLimit = this.value.rewards.salesRedemptionLimit

      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/ViewEvent/ViewPromotion/BuyXGetYOff.js